
import { FETCH_DossierComplet_SUCCESS, FETCH_DossierComplet_FAILURE,REDIRECT_TO_LOGIN } from './actionsTypes';

const initialState = {
  dossierComplet: [],
  error: null,
  redirectToLoginPage: false,
};

const DossierCompletReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DossierComplet_SUCCESS:
      return {
        ...state,
        dossierComplet: action.payload.dossierComplet,
        error: null,
      };
    case FETCH_DossierComplet_FAILURE:
      return {
        ...state,
        dossierComplet: [],
        error: action.payload.error,
      };
    case REDIRECT_TO_LOGIN:
        return {
            ...state,
            redirectToLoginPage: true,
        };
    default:
      return state;
  }
};

export default DossierCompletReducer;
